import { CustomerLogo } from '@sequencehq/core-components'

import { getLogoSrc } from 'Customer/index'
import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { TaskInput } from './types'
import { useInvoiceData } from '../../hooks/useInvoiceData'

export const InvoiceTaxErrorListItem = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, statusIcon } =
    useManualTaskListItemContentToolkit<TaskInput>({
      taskId
    })

  const { invoice, customer } = useInvoiceData(manualTask?.input?.invoiceId)

  if (!manualTask || !invoice) {
    return <InboxListItemContent.Loading />
  }

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      title={
        invoice.invoiceNumber
          ? `${invoice.invoiceNumber}: Invoice tax error`
          : `Invoice tax error`
      }
      description={`Invoice tax error for ${invoice.customerLegalCompanyName}`}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={customer ? getLogoSrc(customer) : undefined}
            size={24}
            fallbackSize={16}
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
